class ProductTransition {
  constructor() {
    this.initialize();
  }

  initialize() {
    this.products = document.querySelectorAll('[data-product]');
    this.element = document.querySelector('[data-product-transition]')
    this.image = this.element.querySelector('img');
    if(!this.products) return;

    this.products.forEach(product => {
      product.addEventListener('click', (e) => {
      const img = e.target;
      const imgEl = img.cloneNode(true);
      img.style.opacity = '0'
      const pos = img.getBoundingClientRect();
      
      this.element.replaceChildren(imgEl);
      this.element.style.display = 'block'
      this.element.style.width = `${pos.width}px`;
      this.element.style.height = `${pos.height}px`;
      this.element.style.left = `${pos.x}px`;
      this.element.style.top = `${pos.y}px`;

      const maxWidth = window.innerWidth <= 768 ? window.innerWidth - 24 : ((window.innerWidth / 2) - 24);
      const maxHeight = window.innerHeight - 24;
      const xPercent = maxWidth / pos.width;
      const yPercent = maxHeight / pos.height;
      const xPos = (pos.left * -1) + ((pos.width * xPercent - pos.width) / 2) + 12;
      const yPos = (pos.y * -1) + ((pos.height * yPercent - pos.height) / 2) + 12;
      
      const finalAspect = maxWidth / maxHeight
      const originalAspect = pos.width / pos.height

      // if(finalAspect < originalAspect) {
      //   console.log(finalAspect / originalAspect)
      // } else {
      //   console.log(originalAspect / finalAspect)
      // }

      // var ratio = Math.min(maxWidth / pos.width, maxHeight / pos.height);

      gsap.to(this.element, {
        width: maxWidth,
        height: maxHeight,
        left: 12,
        top: 12,
        duration: 0.8,
        ease: 'expo.inOut',
        onComplete: () => {
          setTimeout(() => {
            this.element.style.display = 'none';
          }, 500)
        }
      })

      // gsap.to(this.element, {
      //   scaleX: xPercent,
      //   scaleY: yPercent,
      //   x: xPos,
      //   y: yPos,
      //   duration: 1.2,
      //   ease: 'expo.inOut'
      // })
      
      // if(pos.width > pos.height) {
      //   imgEl.style.objectFit = 'contain'
      //   gsap.to(imgEl, {
      //     scaleX: finalAspect / originalAspect,
      //     duration: 1.2,
      //     ease: 'expo.inOut'
      //   })
      // } else {
      //   gsap.to(imgEl, {
      //     scaleX: originalAspect / finalAspect,
      //     duration: 1.2,
      //     ease: 'expo.inOut'
      //   })
      // }
    })
  })
  }
}

const productTransition = new ProductTransition();